export default __webpack_public_path__ + "static/media/LOGO_CHANNEL_SUMMIT_EMEA.0fa8da09.png";